import styled from 'styled-components';

export default function ColorCustomInput(props) {
  const { value, setValue, placeholder, width, disabled, color } = props;

  // 입력값 변경 처리 //
  function onChangeInput(e) {
    setValue(e.target.value);
  }

  return (
    <InputWrapper width={width} disabled={disabled} color={color}>
      <Input
        type='text'
        disabled={disabled}
        placeholder={placeholder}
        value={value}
        color={color}
        onChange={onChangeInput} />
    </InputWrapper>
  )
}

const InputWrapper = styled.div`
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 10px;
  gap: 5px;

  width: ${props => props.width ? `${props.width}px` : '100%'};
  height: 50px;

  background: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};
  border: 1px solid #D4D4D4;
  border-radius: 10px;

  flex-grow: 1;

  &:focus-within {
    border-color: ${props => props.color || '#FF8B48'};
  }

  transition: border-color 0.3s ease-in-out;
`;

const Input = styled.input`
  width: 100%;
  height: 21px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 17px;

  text-align: right;

  color: ${props => props.color || '#232323'};
  background: transparent;

  border: none;
  outline: none;
  padding: 0;

  cursor: ${props => props.disabled ? 'not-allowed' : 'text'};

  ::placeholder {
    color: #CBCBCB;
  }
`;
